<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <input-text :label="'Vendor Name'" :modelName="'k3l_vendor_name'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-date :label="'Tanggal Berdiri'" :modelName="'k3l_tanggal_berdiri'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-text :label="'Alamat Perusahaan'" :modelName="'k3l_alamat'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-address :storeName="'k3lStore'" :mutationName="'k3lStore/SET_K3L_FORM'" :disabled="true" />
      <input-text :label="'Jenis Badan Usaha'" :modelName="'k3l_choosed_bu'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-text :label="'Email Perusahaan'" :modelName="'k3l_email'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />

      <input-perusahaan :storeName="'k3lStore'" :modelName="'child_companies'" :label="'Anak Perusahaan'"
        :sublabel="'(Diisi jika perusahaan memiliki anak perusahaan)'" :isRequired="true"
        :modalName="'modal_add_perusahaan'" :mutationName="'k3lStore/SET_K3L_FORM'" :disabled="true" />

      <input-perusahaan :storeName="'k3lStore'" :modelName="'parent_companies'" :label="'Induk Perusahaan'" :sublabel="'(Diisi jika perusahaan memiliki  Induk Perusahaan/Group Holding)'
        " :isRequired="true" :modalName="'modal_add_induk_perusahaan'" :mutationName="'k3lStore/SET_K3L_FORM'"
        :disabled="true" />

      <input-text :label="'Nama PIC'" :modelName="'k3l_pic_name'" :isRequired="true"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-text :label="'Posisi PIC'" :modelName="'k3l_pic_position'" :isRequired="true"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-text :label="'Email PIC'" :modelName="'k3l_pic_email'" :isRequired="true"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-phone :label="'No. Telpon PIC'" :modelName="'k3l_pic_phone'" :subModelName="'k3l_pic_phone_code'"
        :isRequired="true" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-checkbox :storeName="'k3lStore'" :label="'Apakah perusahaan memiliki kantor tetap di'"
        :mutationName="'k3lStore/SET_K3L_FORM'" :isRequired="false" :disabled="true" />
      <input-bidang :storeName="'k3lStore'" :modelName="'addedKbli'" :label="'Bidang Usaha / Jenis Pekerjaan'"
        :mutationName="'k3lStore/SET_K3L_FORM'" :modalName="'modal_add_kbli'" :isRequired="false" :disabled="true" />
    </div>
    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Selanjutnya
      </div>
    </div>

    <Kbli :storeName="'k3lStore'" :modelName="'addedKbli'" :label="'Bidang Usaha / Jenis Pekerjaan'"
      :mutationName="'k3lStore/SET_K3L_FORM'" :modalName="'modal_add_kbli'" :isRequired="true"
      v-if="$store.state.k3lStore.modal_add_kbli" />
    <add-perusahaan :storeName="'k3lStore'" :modelName="'addedPerusahaan'" :label="'Anak Perusahaan'"
      :mutationName="'k3lStore/SET_K3L_FORM'" :modalName="'modal_add_perusahaan'" :isRequired="true"
      v-if="$store.state.k3lStore.modal_add_perusahaan" />
    <add-perusahaan :storeName="'k3lStore'" :modelName="'addedPerusahaan'" :label="'Induk Perusahaan'"
      :mutationName="'k3lStore/SET_K3L_FORM'" :modalName="'modal_add_induk_perusahaan'" :isRequired="true"
      v-if="$store.state.k3lStore.modal_add_induk_perusahaan" />
  </div>
</template>

<script>
import InputAddress from '../../components/forms/input-address.vue'
import InputBu from '../../components/forms/input-bu.vue'
import InputDate from '../../components/forms/input-date.vue'
import InputPhone from '../../components/forms/input-phone.vue'
import InputText from '../../components/forms/input-text.vue'
import InputPerusahaan from '../../components/forms/input-perusahaan.vue'
import InputBidang from '../../components/forms/input-bidang.vue'
import Kbli from '@/components/customModal/addBidangUsaha.vue'
import InputCheckbox from '../../components/forms/input-checkbox.vue'
import AddPerusahaan from '@/components/customModal/addPerusahaan.vue'
export default {
  components: {
    InputText,
    InputDate,
    InputAddress,
    InputBu,
    InputPhone,
    InputPerusahaan,
    InputBidang,
    Kbli,
    InputCheckbox,
    AddPerusahaan,
  },
  data() {
    return {}
  },
  async created() {
    await this.$store.commit('k3lStore/CALCULATION_1')
    await this.$store.commit('k3lStore/CALCULATION_2')
    await this.$store.commit('k3lStore/CALCULATION_3')
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'register' })
    },
    goNext() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'dokumentasi' })
      // this.$store.commit('SET_NOTIF', 'Dalam Pengembangan')
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
